module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('section', {
    staticClass: "col-xs-12 block bgg formconfi"
  }, [_c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "row",
    domProps: {
      "innerHTML": _vm._s(_vm.pagina.content.rendered)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62af7660"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_formulario.vue
// module id = 139
// module chunks = 0